import { FunctionComponent, ReactNode } from 'react'
import SportsHeaderComponents from '@components/Teaser/SportsHeader'

interface InfoTitleProps {
  isLive: boolean
  children?: ReactNode
}

const { LiveStatusTitle, StatusTitle, StatusTitleWrapper } =
  SportsHeaderComponents

const InfoTitle: FunctionComponent<InfoTitleProps> = ({ isLive, children }) => {
  const Component = isLive ? LiveStatusTitle : StatusTitle

  return (
    <StatusTitleWrapper>
      <Component>{children}</Component>
    </StatusTitleWrapper>
  )
}

export default InfoTitle
